












































import { Vue, Component } from 'vue-property-decorator';
import {
  NavbarApps,
  NavbarAppItem,
  NavbarCustomer,
  Footer,
  LayoutService,
  NavbarCustomerSelection,
  NavbarCustomerSelectionItem,
  NavbarCustomerSelectionCaptions,
} from '@step/vue';
import { namespace } from 'vuex-class';
import { IAuthorizationService, ILayoutServiceOptions, ILocalizationService } from '@step/vue/src/layouts/types';
import { layoutPrototypeKey } from '@step/vue/src/layouts/constants';
import { Popup } from '@/components';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { apiService, customerService } from '@/container';
import { configuration } from '@/configuration';

const authorizationVuexNamespace = namespace('step_authorization');
@Component({
  components: {
    Footer,
    NavbarApps,
    NavbarCustomer,
    NavbarCustomerSelection,
    Popup, DxToolbarItem
  }
})
export default class Layout extends Vue {
  @authorizationVuexNamespace.Getter currentUserCompleteName!: string | null;
  @authorizationVuexNamespace.State currentUser: any;

  openState = false;
  logoutForm = 'logout-form';
  showCustomerPopup = false;
  customerCode: string | null = null;

  public customers: NavbarCustomerSelectionItem[] = [
    new NavbarCustomerSelectionItem('Customer 1', '1'),
    new NavbarCustomerSelectionItem('Customer 2', '2'),
    new NavbarCustomerSelectionItem('Customer 3', '3')
  ];

  public navbarCustomerSelectionCaptions = new NavbarCustomerSelectionCaptions('Customer', 'Company', 'Site');

  get options(): ILayoutServiceOptions {
    const self = this as Vue & { [key: string]: any };

    return self[layoutPrototypeKey] !== undefined
      && self[layoutPrototypeKey].options !== undefined
      ? self[layoutPrototypeKey].options
      : {};
  }

  async getCode() {
    if (this.customerId) {
      const customer = await apiService.get<ICustomerItem>('customer', `${this.customerId}`, null,
        {
          axiosConfig: {
            baseURL: configuration.authBackendBaseUrl
          }
        });
      this.customerCode = customer.Code;
    }
  }

  get logo(): any {
    this.getCode();
    return this.customerCode + '.png';
  }

  get getImgUrl() {
    try {
      return require(`@/assets/customer-logos/${this.logo}`);
    }
    catch (e) {
      return require('@/assets/logoStep-default.png');
    }
  }

  get internalLayoutService(): LayoutService {
    const self = this as Vue & { [key: string]: any };
    return self[layoutPrototypeKey];
  }

  get internalAuthorizationService(): IAuthorizationService {
    return this.options?.authorizationService;
  }

  get internalLocalizationService(): ILocalizationService {
    return this.options?.localizationService;
  }

  get internalNavbarAppItem(): NavbarAppItem[] {
    const item: NavbarAppItem[] = [];

    this.options.navbarAppItem.forEach(x => item.push(new NavbarAppItem(this.internalLocalizationService.translate(x.name), x.href, x.disabled)));
    return item;
  }

  get availableRoutes() {
    return this.$router.options.routes?.filter(r =>
      r.meta?.includeInDrawer === true
      && (!Array.isArray(r.meta.visibleTo)
        || this.internalAuthorizationService.permissionsService.hasAny(r.meta.visibleTo)))
      .map((r, index) => ({
        id: index,
        name: this.internalLocalizationService.translate(r.name ?? ''),
        routeName: r.name,
        template: 'menu-item'
      }));
  }

  /*
  itemClick({ itemData }) {
    if (itemData.routeName !== this.$route.name)
      this.$router.push({ name: itemData.routeName });
  }*/


  get userFullName() {
    return this.currentUserCompleteName;
  }

  get showMenu() {
    if ((this.availableRoutes !== undefined)
      && (this.availableRoutes?.length > 0))
      return true;
    return false;
  }

  get userLevel() {
    return this.currentUser === null ? '' : this.currentUser.role;
  }

  get customerName() {
    return customerService.getCustomerName();
  }

  get customerId() {
    return customerService.getCustomer();
  }

  get inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  onChangeCustomer() {
    this.$emit('changeCustomer');
  }

  logout() {
    this.$emit('logout');
  }

  mounted() {
    let element = document.getElementsByClassName('navbar-brand font-weight-bold') as HTMLCollectionOf<HTMLAnchorElement>;
    if (element.length !== 0) {
      element[0].href = '/';
    }
  }
}
interface ICustomerItem {
  Id: string;
  BusinessName: string;
  Code; string;
}
